import ReceiptPaymentService from './ReceiptPaymentService'
// import ReceiptEntryRoutes from './route-types'
import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'
import router from '@/router'
// import { md5 } from '@/components/crypto'
//import { md5 } from '@/components/crypto'
// import { nowDate } from '@/components/utils/DateTimeFunctions'

const tag = 'receiptpayment'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  readOnlyView: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  readOnlyView: state => state.readOnlyView
}

const actions = {
  async getStoreItem({ commit }, id) {
    console.log('GetStoreItem')
    // const entity = StoreUtil.getStorage(id, tag) || (await QuickInvoiceService.getEntity(id, ''))
    // The following for refreshing data from WebApi regardless
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const data = await ReceiptPaymentService.getEntity(id)
      if (data) {
        console.log('from WebApi')
        // const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
        // data.invoiceItems.forEach(i => (i.receivedDate = utcDate.split('.')[0] + 'Z'))
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    StoreUtil.setStorage(entity.assetID, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async editStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await ReceiptPaymentService.getEntityByPamentId(id))
    // const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
    // entity.invoiceItems.forEach(i => (i.receivedDate = utcDate.split('.')[0] + 'Z'))
    StoreUtil.setStorage(entity.customerId, tag, entity)
    commit('saveInitialSnapshots', entity)
    router.push({ path: `receiptentry/receiptpayment/${id}`})
    //StoreUtil.routeToDetail(FactorInvoiceRoutes.FactorInvoiceDetail.path, entity.invoiceId, false)
  },
  async addStoreItem({ commit }) {
    //const entity = await QuickItemService.getNewEntity()
    //StoreUtil.setStorage(entity.itemQuickId, tag, entity)
    commit('saveInitialSnapshots', entity)
    //StoreUtil.routeToDetail(QuickItemRoutes.QuickItemListView.path, entity.itemQuickId, true)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  setReadOnlyView({ commit }, value) {
    commit('setReadOnlyView', value)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  },
  setReadOnlyView(state, value) {
    state.readOnlyView = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
